import React, { useEffect, useState } from "react";
import { Search, Plus, Minus } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function AdminCustomers() {
  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = async (query = "") => {
    setBusy(true);
    try { const { data } = await api.get(`/admin/customers?q=${encodeURIComponent(query)}`); setRows(data); }
    catch { toast.error("Could not load customers"); } finally { setBusy(false); }
  };
  useEffect(() => { load(""); }, []);

  const adjust = async (c) => {
    const raw = window.prompt(`Adjust points for ${c.name || c.email}\nCurrent balance: ${c.loyalty_points}\n\nEnter a positive number to add or negative to deduct:`, "");
    if (raw === null) return;
    const delta = parseInt(raw, 10);
    if (!delta || isNaN(delta)) { toast.error("Enter a whole number, e.g. 50 or -20"); return; }
    try {
      const { data } = await api.post(`/admin/customers/${c.id}/points`, { delta });
      setRows((prev) => prev.map((x) => (x.id === c.id ? { ...x, loyalty_points: data.loyalty_points } : x)));
      toast.success(`Balance updated to ${data.loyalty_points} pts`);
    } catch { toast.error("Could not update points"); }
  };

  return (
    <div className="space-y-5">
      <h1 className="font-heading font-extrabold text-3xl text-metros-black">Customers</h1>
      <p className="text-sm text-muted-foreground -mt-2">Search customers, view their loyalty points, and add or deduct points manually (e.g. for walk-in orders).</p>

      <form onSubmit={(e) => { e.preventDefault(); load(q); }} className="flex gap-2 max-w-md">
        <div className="flex-1 flex items-center gap-2 bg-white border border-gray-200 rounded-xl px-3">
          <Search size={16} className="text-gray-400" />
          <input data-testid="customer-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by name or email" className="flex-1 py-2.5 text-sm outline-none" />
        </div>
        <button type="submit" data-testid="customer-search-btn" className="bg-metros-black text-white rounded-xl px-5 text-sm font-bold">Search</button>
      </form>

      <div className="bg-white border border-gray-100 rounded-2xl divide-y divide-gray-50">
        {busy && <p className="p-4 text-sm text-muted-foreground">Loading…</p>}
        {!busy && rows.length === 0 && <p className="p-4 text-sm text-muted-foreground">No customers found.</p>}
        {rows.map((c) => (
          <div key={c.id} data-testid={`customer-${c.id}`} className="flex items-center justify-between gap-3 p-4">
            <div className="min-w-0">
              <p className="font-semibold text-metros-black truncate">{c.name || "—"}</p>
              <p className="text-xs text-muted-foreground truncate">{c.email}</p>
            </div>
            <div className="flex items-center gap-3 shrink-0">
              <span data-testid={`customer-points-${c.id}`} className="font-heading font-extrabold text-metros-red text-lg">{c.loyalty_points} pts</span>
              <button data-testid={`customer-adjust-${c.id}`} onClick={() => adjust(c)} className="flex items-center gap-1 bg-metros-red text-white rounded-full px-4 py-2 text-sm font-bold"><Plus size={14} />/<Minus size={14} /> Adjust</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
